/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { UsersListComp, Header } from '../components';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { useTheme } from '../../../providers/theme';

import { Paginate } from '@vlinder-web/paginate-widget-react';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { vappContainer, VApplication } from '../../../application';
import { SettingsComp } from '../components/Settings';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';
import { PaymentHistoryPageService } from '../services';
import {
  useSMPaymentReportPageGetContent,
  // useSMDeleteDraft,
  useSMPaymentTxnReport

} from '../machines';
import { useNavigate } from 'react-router-dom';
import RouteConfig from '@/AppNavigator/services/config/routes.config.json';
import { AppNavigatorService } from '@/AppNavigator';
import { USER_LEVEL } from '@/config/userManagement.config';
import { Loader } from '@/components';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { ReportModal } from '../components/ReportModal';

const getSrv = () => {
  return vappContainer.get<PaymentHistoryPageService>(
    PaymentHistoryPageService.displayName
  );
};

const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshPagination, setReFreshPagination] = useState(new Date());
  const [showFeatureModal, setShowFeatureModal] = useState<boolean>(false);
  const staticPageContentConfig = getSrv()?.agent?.getStaticPageContentSync({});
  const [whoAmI, setWhoAmI] = useState('');
  const appSrv = getAppSrv();
  const storageSrv = StorageModule?.getInstance();
  const userProfile = storageSrv.get('myProfile', 'session');
  const role = userProfile?.org?.orgRole;
  const vuid = userProfile?.vuid;
  // const formDataConfig = getSrv()?.agent.getFormData();
  const [roe, setRoe] = useState(false);
  const [whereState, setWhereState] = useState<any>([]);

  useEffect(() => {
    if (role === 'CARICOM_BUSSINESS_ORG') setRoe(true);
  }, [role]);
  const { getPaymentReportPageSend, getPaymentReportPageState } =
    useSMPaymentReportPageGetContent({});


  const {paymentTxnReportMachine,paymentTxnReportSend,paymentTxnReportState} = useSMPaymentTxnReport({})
  // const { deleteDraftSend, deleteDraftMachine, deleteDraftState } =
  //   useSMDeleteDraft({});

  const _onHeaderDDActionItemClick = (id: string) => {};
  const onAddUser = (id: string) => {
    if (!showModal) {
      setShowModal(true);
    }
  };

  useEffect(() => {
    getWhoamI();
  }, []);
  const _onViewClick = (id: string, data: any) => {
    console.log(`_onViewClick`, id, data);
    navigate(`${RouteConfig?.routes?.ApplicationDetail?.path}?id=${id}`);
  };

  const onHeaderAction2Click = (id: string) => {
    console.log("id inside download",id)
    if (id) {
      switch (id) {
        case 'import_users':
          toast.success('Coming soon!');
          // history.push(
          //   `${routesConfig?.routes?.UsersBatch?.path}`
          // );
          break;
        default:
          console.log(`unsupported header button id ${id} clicked`);
      }
    }
  };
  
  const onReportDownload = (startdate: any, enddate: any) =>{

   
    let criteria = {

      startDate: startdate,
      endDate: enddate
    };
    paymentTxnReportSend('START',{
      payload:{criteria},
    });
    console.log("datainsidecriteria==>", criteria)
    setShowFeatureModal(false)

  }



  const onRefresh = () => {
    getPaymentReportPageSend('TRIGGER_REFRESH', {});
    setReFreshPagination(new Date());
  };
  const onFeature = (id: string) => {
    // if (!showFeatureModal) {
      setShowFeatureModal(true);
    // }
  };
  const onModalClose = ()=>setShowFeatureModal(false);
  const _FeatureModal = () => {
    if (showFeatureModal) {
      return (
        <ReportModal
        
          showModal={showFeatureModal}
          onAcknowledgement={onReportDownload}
          onDeny={onModalClose}
          fields={staticPageContentConfig?.downloadFormData?.FIELDS}
          layout={staticPageContentConfig?.downloadFormData?.layout}
        />
      );
    }
  };
  const onClearFilter = () => {
    Array.from(document.querySelectorAll('input')).forEach(
      (input) => (input.value = '')
    );
    getPaymentReportPageSend('TRIGGER_REFRESH', {});
  };

  const onApplyFilter = (data: any, statusFilter: any, paymentFilter: any) => {
    console.log(`Asirdata on apply filter`, data,statusFilter, paymentFilter);
    let criteria: any = [];
    if (data?.applicationNo) {
      criteria = [
        {
          column: 'applicationNo',
          op: 'Equal',
          value: data?.applicationNo,
        },
      ];
    }
    if(data?.paymentId) {
      criteria = [
        {
          column: 'paymentId',
          op: 'Equal',
          value: data?.paymentId,
        },
      ];
    }
    if(data?.orgName) {
      criteria = [
        {
          column: 'orgName',
          op: 'Equal',
          value: data?.orgName,
        },
      ];
    }
    if(data?.appId) {
      criteria = [
        {
          column: 'applications',
          op: 'Equal',
          value: data?.appId,
        },
      ];
    }
    
    if (statusFilter) {
      criteria = [
        ...criteria,
        {
          column: 'status',
          op: 'Equal',
          value: statusFilter,
        },
      ];
    }
    if (paymentFilter) {
      criteria = [
        ...criteria,
        {
          column: 'type',
          op: 'Equal',
          value: paymentFilter,
        },
      ];
    }
    setWhereState(criteria);
    getPaymentReportPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };
  console.log('contwhoam', whoAmI);
  const getWhoamI = async () => {
    const { whoami } = await appSrv.whoAmI();
    setWhoAmI(whoami);
  };

  const onTogglePress = (key: string, id: string) => {
    console.log('tott', key, id);
    if (key === 'delete') {
      // deleteDraftSend('START', {
      //   payload: id,
      // });
    }
    // if (key === 're-invite') {
    //   console.log('reinvite id', id);
    //   reInviteUserSend('START', {
    //     payload: id,
    //   });
    // }
    // if (key === 'activate') {
    //   activateUserSend('START', {
    //     payload: id,
    //   });
    // }
  };
  const _renderPage = () => {
    // if (deleteDraftState?.matches('DELETE_USER')) {
    //   return (
    //     <Loader {...(staticPageContentConfig?.loading?.deleteDraft || {})} />
    //   );
    // }
    if (
      getPaymentReportPageState?.matches('RENDER_PAGE') &&
      getPaymentReportPageState?.event?.data?.value
    ) {
      console.log(
        `getPaymentReportPageState :`,
        getPaymentReportPageState?.event?.data?.value,
        staticPageContentConfig
      );
      return (
        <>
          {getPaymentReportPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(staticPageContentConfig?.loading?.usersEmpty || {})}
            />
          ) : (
            <UsersListComp
              {...getPaymentReportPageState?.event?.data?.value}
              // {...(getPaymentReportPageState?.event?.data?.value || {})}
              onViewClick={_onViewClick}
              // onRowClick={props?.onViewDetailClick}
              // onRowClick={_onViewClick}
              whoAmI={whoAmI}
              onTogglePress={onTogglePress}
            />
          )}
        </>
      );
    }
    if (getPaymentReportPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.loadingUsers || {})} />
      );
    }
  
    return <></>;
  };

  const _renderDownloadcsv = ()=>{
    if (paymentTxnReportState?.matches('DOWNLOAD_PAYMENT_CSV')) {
      return (
        <Loader
        useModalLoader={true}
         {...(staticPageContentConfig?.loading?.downloadReport || {})} />
      );
    }
  }

  

  const openCSVInNewWindowFromBase64 = async (base64str:any, filename:any) => {
    const token = appSrv?.getToken()

    const authToken = token;
  
    const headers = new Headers({
      Authentication: authToken,
     
    });
  
    try {
      const response = await fetch(base64str, {
        method: 'GET',
        headers: headers,
      });
  
      if (response.ok) {

        const blob = await response.blob();
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.target = '_blank';
        downloadLink.download = filename;

        document.body.appendChild(downloadLink);
  
        downloadLink.click();

        document.body.removeChild(downloadLink);
      } else {
        console.error(`Failed to fetch CSV file. Status: ${response.status}`);
      }
    } catch (error) {
      console.error('Error fetching CSV file:', error);
    }
  };

  const _renderCSVDownload = () => {
    console.log(
      "getDeliveredReportState?.event?.data?.value==>",
      paymentTxnReportState?.event?.data?.value
    );
    if (paymentTxnReportState?.matches("DOWNLOAD_PAYMENT_CSV_SUCCESS")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.downloadCSVSuccess ||
            {})}
          // onAcknowledgement={() => {

          //   // openCSVInNewWindowFromBase64(
          //   //   getDeliveredReportState?.event?.data?.value?.csvUrl,
          //   //   "Delivered_Report"
          //   // );
          // }}
          onAcknowledgement={() => {
            openCSVInNewWindowFromBase64(
              paymentTxnReportState?.event?.data?.value?.csvUrl,
              "Transaction_report"
            );
          }}
          onDeny={() => {}}
        />
      );
    }
    return null;
  };



  const _renderHeader = () => {
    console.log("seetting", staticPageContentConfig?.settings || {}
    );
    if (staticPageContentConfig?.header) {

      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onHeaderAction1Click={onAddUser}
            onHeaderDDActionItemClick={_onHeaderDDActionItemClick}
            onHeaderAction2Click={onHeaderAction2Click}
            onRefreshClick={onRefresh}
          />
          {/* <SearchFilter
            {...(staticPageContentConfig?.settings || {})}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          /> */}
          <SettingsComp
            {...staticPageContentConfig?.settings || {}}
            onApplyFilter={onApplyFilter}
            onClearFilter={onClearFilter}
            downloadCsvReport={onFeature}
          />
        </>
      );
    }
    return null;
  };

  const onPaginationChange = (event: any) => {
    getPaymentReportPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
      where: whereState,
    });
  };

  const _renderPagination = () => {
    if (!getPaymentReportPageState?.event?.data?.value?.isEmpty) {
      console.log("asdfasjdfahsdfjasdfhadsfashdfasfsdf",getPaymentReportPageState?.event?.data?.value,getPaymentReportPageState?.event?.data?.value?.ultUsers?.length);
      return (
        <Paginate
          {...(getPaymentReportPageState?.event?.data?.value || {})}
          onPageChange={onPaginationChange}
          key={refreshPagination}
          totalItems={
            getPaymentReportPageState?.event?.data?.value?.ultUsers?.length
          }
        />
      );
    }
  };

  const _renderCSVDownloadFailure = () => {
    if (paymentTxnReportState?.matches("DOWNLOAD_PAYMENT_CSV_FAILED")) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.csvFailure || {})}
          // description={[getDeliveredReportState?.event?.data?.value]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderErrorModals = () => {
    if (getPaymentReportPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getApplications || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    // if (deleteDraftState?.matches('DELETE_USER_FAILED')) {
    //   return (
    //     <NotificationModal
    //       showModal={true}
    //       {...(staticPageContentConfig?.error?.deleteDraft || {})}
    //       description={[
    //         deleteDraftState?.event?.data?.value,
    //         staticPageContentConfig?.error?.deleteDraft?.description[1],
    //       ]}
    //       onAcknowledgement={onRefresh}
    //       onDeny={onRefresh}
    //     />
    //   );
    // }
  };

  const _renderNotifications = () => {
    // if (deleteDraftState?.matches('DELETE_USER_SUCCESS')) {
    //   return (
    //     <NotificationModal
    //       showModal={true}
    //       {...(staticPageContentConfig?.notifications?.deleteDraftSuccess ||
    //         {})}
    //       onAcknowledgement={onRefresh}
    //       onDeny={onRefresh}
    //     />
    //   );
    // }

    return null;
  };

  return (
    <div>
      {_renderHeader()}
      {_renderPage()}
      {_renderPagination()}
      {_renderErrorModals()}
      {_renderNotifications()}
      {_renderDownloadcsv()}
      {_renderCSVDownload()}
      {_renderCSVDownloadFailure()}
      {_FeatureModal()}
    </div>
  );
};
